import { RootState } from '../../reducers'
import { CollapseUnion } from '@feedyou/utils'
import { ModalDescriptor } from './types'

export const openModalDescriptorSelector = (state: RootState) => state.modals.openModal

export const openModalSectionSelector = (
  state: RootState
): CollapseUnion<ModalDescriptor>['openSection'] => {
  // @ts-ignore
  return openModalDescriptorSelector(state)?.openSection
}

export function isCustomIntegrationServiceEnabledSelector(service: string): boolean {
  // @ts-ignore
  if (!window?.CUSTOM_INTEGRATION_SERVICES) {
    return false
  }

  // @ts-ignore
  if (window?.CUSTOM_INTEGRATION_SERVICES === '*') {
    return true
  }

  return (
    // @ts-ignore
    window.CUSTOM_INTEGRATION_SERVICES?.toUpperCase().split(',').includes(service.toUpperCase())
  )
}
